module.exports = __webpack_public_path__ + "img/alentour8.2681bae2.jpg";